export default __webpack_public_path__ + "static/B0093-76b0e02ae400406b0456c60cc0a6bed6.png";